<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Stores' : 'Deleted Stores'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/stores/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="states"
                    solo
                    rounded
                    v-model="filter.state_id"
                    :items="stateItems"
                    clearable
                    @click:clear="(filter.state_id = null), (page = 1)"
                    label="States"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="store"
                    solo
                    rounded
                    v-model="filter.store_id"
                    :items="storeItems"
                    clearable
                    @click:clear="(filter.store_id = null), (page = 1)"
                    label="Store"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.store_type"
                    :items="storeTypeItems"
                    clearable
                    @click:clear="(filter.store_type = null), (page = 1)"
                    label="Store Type"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <!-- Month Year -->
                <v-col sm="2">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.month_year"
                        label="Year - Month"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.month_year = null"
                        hide-details
                        :error-messages="errors.month"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @input="
                        getData();
                        month_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Month Year -->
                <!-- Start date -->
                <v-col sm="2">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.start_date"
                        label="Start Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.start_date = null"
                        hide-details
                        :error-messages="errors.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col sm="2">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.end_date"
                        label="End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.end_date = null"
                        hide-details
                        :error-messages="errors.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="stores.length != 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    rounded
                    depressed
                    color="error"
                    class="my-auto"
                    @click="deleteAll(stores.id)"
                    style="width: 60px; height: 40px"
                  >
                    <v-icon dark> mdi-delete </v-icon>
                  </v-btn>
                </template>
                <span>Delete all Store</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">State</th>
                      <th class="text-left" style="min-width: none">
                        Store Type
                      </th>
                      <th class="text-left" style="min-width: none">Name</th>
                      <th class="text-left" style="min-width: none">
                        Location
                      </th>
                      <th class="text-left" style="min-width: none">
                        Store Code
                      </th>
                      <th class="text-left" style="min-width: none">
                        Ownership
                      </th> <th class="text-left" style="min-width: none">
                        Total Current Gift
                      </th>
                      <th class="text-right action_th" style="min-width: 200px">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="stores.length != 0">
                    <tr
                      v-for="(store, i) in stores"
                      :key="`store_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': stores.length - 1 == i,
                      }"
                    >
                      <td>
                        <input type="checkbox" v-model="store.is_selected" />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="store.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Store is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="store.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Store is InActive</span>
                        </v-tooltip>
                      </td>

                      <td>
                        {{ store.state_jurisdiction || "" }}
                      </td>
                      <td>
                        {{ store.store_type == 1 ? "Company" : "Franchisee" }}
                      </td>
                      <td>
                        {{ store.business_name || "" }}
                      </td>
                      <td>
                        {{ store.store_location || "" }}
                      </td>
                      <td>
                        {{ store.store_code || "" }}
                      </td>
                      <td>
                        {{ store.owner?.user_name || "" }}
                      </td>
                        <td>
                        {{ store.available_gift_quantity || "" }}
                      </td> 
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/stores/${encryptIt(
                                  store.id
                                )}/store-gifts`"
                              >
                                <v-icon dark> mdi-gift </v-icon>
                              </v-btn>
                            </template>
                            <span>View Mapped Gifts</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/stores/${encryptIt(
                                  store.id
                                )}/store-products`"
                              >
                                <v-icon dark> mdi-package-variant </v-icon>
                              </v-btn>
                            </template>
                            <span>View Mapped Products</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(store.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Store</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/stores/${encryptIt(store.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Store</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(store.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this store</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_store" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_store = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "StoresPage",
  data() {
    return {
      form: {},
      filter: {
        search_keyword: "",
        store_type: "",
        store_id: "",
        state_id: "",
        is_active: "",
        is_selected: false,
        month_year: "",
        start_date: "",
        end_date: "",
      },
      storeItems: [],
      stateItems: [],
      stores: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      storeTypeItems: [
        {
          id: 0,
          text: "Owner",
          value: "",
        },
        { id: "COMPANY OWNER", text: "COMPANY OWNER", value: 1 },
        { id: "FRANCHISEE", text: "FRANCHISEE", value: 2 },
      ],
      ExportRawMaterialTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      is_restored_store: false,
      isExcelloading: false,
      delete_store: false,
      is_deleted_store: false,
      is_select_all: false,
      isDeleteAll: false,
      month_menu: false,
      start_menu: false,
      end_menu: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`stores/masters`)
        .then((masters) => {
          masters = masters.data;
          //State
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.name,
              value: state.name,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state_id ? this.filter.state_id : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.store_id = this.filter.store_id ? this.filter.store_id : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      this.filter.store_type = this.filter.store_type
        ? this.filter.store_type
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_id=" +
        this.filter.store_id +
        "&store_type=" +
        this.filter.store_type +
        "&state=" +
        this.filter.state +
        "&city=" +
        this.filter.city +
        "&month_year=" +
        this.filter.month_year +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`stores?${query}`)
        .then((response) => {
          this.stores = response.data.data;
          //Store
          this.stores.forEach((store) => {
            this.storeItems.push({
              id: store.id,
              text: store.business_name,
              value: store.business_name,
            });
          });
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);

          //window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state_id = this.filter.state_id ? this.filter.state_id : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.store_id = this.filter.store_id ? this.filter.store_id : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_id=" +
        this.filter.store_id +
        "&state_id=" +
        this.filter.state_id +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/stores/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    async Delete_this(id) {
      this.delete_store = true;
      await axios
        .post(`/stores/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_store = false;
          this.is_deleted_store = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);

          //window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.stores.forEach((store) => {
        store.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.stores.forEach((store) => {
        if (store.is_selected) deleteallIds.push(store);
      });
      await axios
        .post("/stores/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },

    async Restore_this(id) {
      this.restore_store = true;
      await axios
        .post(`/stores/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_store = false;
          this.is_restored_store = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
